import type { GetLocaleTextParams } from 'ag-grid-community';
import type { IntlKey } from 'locales';
import { useCallback } from 'react';

import { useSPIntl } from '../useIntl';

export function useAgGridIntl() {
  const { formatMessage } = useSPIntl();
  return useCallback(
    ({ key, defaultValue }: GetLocaleTextParams) => {
      const id: IntlKey = ('agGrid.' + key) as any;
      return formatMessage({ id, defaultMessage: defaultValue });
    },
    [formatMessage],
  );
}
